import { useState, useEffect } from 'react';
import { Background, Container, Table, Header, ScrollTable, ShowIcon } from './style';
import api from '../../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../../components/GoBack';
import { TokenPerfil, userId } from '../../../services/TokenData';
import ModalEdit from '../../../components/Modal/Gestor/EditSolicitacao';
import DropdownMenu from '../../../components/Dropdown';

export default function SolicitacoesProcessos() {
    const [Dados, setDados] = useState([]);
    const [DadosSolicitacao, setDadosSolicitacao] = useState([]);
    const [ShowModalEdit, setShowModalEdit] = useState(false);
    const [Reload, setReload] = useState(false);
    const Location = useLocation();
    const Navigate = useNavigate();
    const UserId = userId();
    const [tipoSolicitacao, setTipoSolicitacao] = useState('Minhas Solicitações');
    const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
    const [solicitacoesRecebidas, setSolicitacoesRecebidas] = useState([]);

    const getMinhasSolicitacoes = async () => {
        try {
            const res = await api.get(`/solicitacoes/enviadas/${UserId}`);
            setMinhasSolicitacoes(res.data.minhasSolicitacoes);
        } catch (e) {
            console.error(e);
        }
    };

    const getSolicitacoesRecebidas = async () => {
        try {
            const res = await api.get(`/solicitacoes/recebidas/${UserId}`);
            setSolicitacoesRecebidas(res.data.solicitacoesRecebidas);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (tipoSolicitacao === 'Minhas Solicitações') {
            getMinhasSolicitacoes();
        } else {
            getSolicitacoesRecebidas();
        }
    }, [tipoSolicitacao]);

    function AlertaCor(dados) {
        if (dados?.situacao === 'Aprovada') {
            return 'G';
        }
        if (dados?.situacao === 'Reprovada') {
            return 'R';
        } else {
            return '';
        }
    }

    const arrayDeSolicitacoes = tipoSolicitacao === 'Minhas Solicitações' ? minhasSolicitacoes : solicitacoesRecebidas;
    return (
        <Background>
            <GoBack />
            <Container>
                <Header>
                    <div style={{ width: 'fit-content', display: 'flex', gap: '15px', alignItems: 'center' }}>
                        <h1>{'Prorrogação de Prazo'} </h1>
                        <h1>-</h1>
                        <DropdownMenu
                            lista={['Minhas Solicitações', 'Solicitações Recebidas']}
                            status={tipoSolicitacao}
                            setStatus={setTipoSolicitacao}
                            border={'10px'}
                            minWidth={'50px'}
                        />
                    </div>
                </Header>
                <ScrollTable>
                    <Table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>{TokenPerfil() === 'GESTOR' ? 'N° Processo' : 'Desc. Ocorrência'}</th>
                                <th>Seq.</th>
                                <th>Destinatário</th>
                                <th>Qtde. Dias</th>
                                <th>Justificativa</th>
                                <th>Data da Solicitação</th>
                                <th>Situação</th>
                                <th>Motivo</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {arrayDeSolicitacoes?.map((d, i) => (
                                <tr
                                    key={i}
                                    onClick={() => {
                                        setDadosSolicitacao(d);
                                        setShowModalEdit(true);
                                    }}
                                >
                                    <td>{i + 1}</td>
                                    <td title={d?.numero_processo}>{d?.numero_processo}</td>
                                    <td title={d?.nivel_ocorrencia ? `${d?.seq_ocorrencia}.${d?.nivel_ocorrencia}` : d?.seq_ocorrencia || '-'}>
                                        {d?.nivel_ocorrencia ? `${d?.seq_ocorrencia}.${d?.nivel_ocorrencia}` : d?.seq_ocorrencia || '-'}
                                    </td>
                                    <td>{d?.destinatario}</td>
                                    <td>{d?.quantidade_dias}</td>
                                    <td>{d?.justificativa_solicitacao}</td>
                                    <td>{d?.data_solicitacao}</td>
                                    <td className={AlertaCor(d)}>{d?.situacao}</td>
                                    <td>{d?.motivo_situacao || '-'}</td>
                                    <td>
                                        <ShowIcon
                                            onClick={() =>
                                                Navigate('/gestor/processo', {
                                                    state: {
                                                        IdOcorrencia: d?.id_processo,
                                                        seq_ocorrencia: d?.seq_ocorrencia,
                                                        NumProcesso: d?.numero_processo,
                                                    },
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ScrollTable>
            </Container>
            <ModalEdit
                Show={ShowModalEdit}
                setShow={setShowModalEdit}
                Reload={Reload}
                setReload={setReload}
                DadosSolicitacao={DadosSolicitacao}
                NumProcesso={Dados?.id_processo}
            />
        </Background>
    );
}
